import { Box, Typography, Divider } from "@mui/material";

/**
 * FormSection renders a titled section with optional subtitle and children.
 * Commonly used to group related form fields with a visual divider.
 *
 * @param title - The section heading
 * @param subtitle - Optional description below the title
 * @param children - Form inputs or other content
 */
export const FormSection: React.FC<{
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}> = ({ title, subtitle, children }) => (
  <Box mt={3}>
    <Typography variant="h6" gutterBottom>
      {title}
    </Typography>
    {subtitle && (
      <Typography pb={2} variant="body2" color="text.secondary" gutterBottom>
        {subtitle}
      </Typography>
    )}
    <>{children}</>
    <Divider sx={{ mt: 2 }} />
  </Box>
);
